import { IWorkSpaceRepository } from "@/core/repositories/workspace";

export class GetWorkspaceUserPermissionsUseCase {
  constructor(private readonly workspaceRepository: IWorkSpaceRepository) {}

  async execute(): Promise<string[]> {
    const workSpaceUserPermissions = await this.workspaceRepository.getWorkspaceUserPermissions();
    return workSpaceUserPermissions?.permissions ?? [];
  }
}
